import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tabActive1",
  "use": "icon-tabActive1-usage",
  "viewBox": "0 0 2430 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2430 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tabActive1\"><path d=\"M2430.089552 0a229.559403 229.559403 0 0 0-207.856716 150.573851l-191.70197 569.955343A198.686567 198.686567 0 0 1 1842.206567 855.880597H168.119403C79.596896 855.880597 0 929.471045 0 1024V239.18806C0 102.461134 119.823284 0 234.679403 0H2430.089552z\" p-id=\"4068\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol